import React, { useContext } from "react";
import { useNavigate } from "react-router-dom";
import AIDashboardChatbox from "../../AIDashboardChatbox";
import { ThemeContext } from "../../context/themeContext";
import { ArrowLeft } from "lucide-react";
import "./MMAiPage.css";

export default function MMAiPage() {
  const { activeTheme } = useContext(ThemeContext);
  const navigate = useNavigate();

  return (
    <section className={`mm-ai-chat-page ${activeTheme === "dark" ? "dark-mode" : ""}`}>
      <div className="mm-ai-topbar">
        <button className="mm-ai-back-btn" onClick={() => navigate(-1)} aria-label="Go back">
          <ArrowLeft size={20} />
        </button>
        <div className="mm-ai-brand">
          <img src="/image/Chatbot-image.png" alt="MM AI" className="mm-ai-brand-icon" />
          <div className="mm-ai-brand-text">
            <span className="mm-ai-brand-name">MarsMate AI</span>
            <span className="mm-ai-brand-status">
              <span className="mm-ai-status-dot" />
              Online
            </span>
          </div>
        </div>
      </div>
      <div className="mm-ai-chat-body">
        <AIDashboardChatbox />
      </div>
    </section>
  );
}
